import React, { useState, useEffect } from "react";

import IconsSidebar from "@Shared/Components/IconsSidebar";
import MacroIconView from "@Shared/Components/MacroIcon/MacroIconView";
import { MACRO_EDIT_EVENTS } from "@Shared/events/macro-edit-events";

import { getIconType } from "../icon/Icon";

import { IconPickerContainer, IconPickerLabel, IconPickerTile } from "./styles";

const IconPicker = ({ icon, onChange, tabs, defaultTab }) => {
  const [isOpen, setIsOpen] = useState(false);

  const iconType = getIconType(icon);

  useEffect(() => {
    window.AP.events.on(MACRO_EDIT_EVENTS.OPEN_ICON_PICKER, () =>
      setIsOpen(true)
    );
  }, []);

  return (
    <>
      <IconPickerContainer onClick={() => setIsOpen(true)}>
        {!icon || (
          <IconPickerTile>
            {iconType === "emoji" && icon.native}

            {iconType === "icon" && (
              <MacroIconView icon={icon} style={{ lineHeight: "0" }} />
            )}

            {iconType === "app" && (
              <img src={icon} alt="img" width="20" height="20" />
            )}
          </IconPickerTile>
        )}

        <IconPickerLabel>{icon?.name || icon || "Select icon"}</IconPickerLabel>
      </IconPickerContainer>

      <IconsSidebar
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        containerStyles={{ top: "75px" }}
        onIconChange={(value) => {
          onChange({ value, type: "icon" });
          setIsOpen(false);
        }}
        onEmojiChange={(value) => {
          onChange({ value, type: "emoji" });
          setIsOpen(false);
        }}
        onAppChange={(value) => {
          onChange({ value, type: "app" });
          setIsOpen(false);
        }}
        selectedIcon={icon?.value}
        tabs={tabs}
        activeTab={defaultTab}
      />
    </>
  );
};

export default IconPicker;
